module.exports = __webpack_public_path__ + "static/img/SI@3x.e81f2886.jpg";